import { defineFcm } from '../shared/factory';

export const FCM_GOOGLE_AUTH = defineFcm('google_auth').asBoolean().withDefault(false).toConfig();
